import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import './HotelDetailOrderSummarySelectedContent.scss';

import { ReservationItem } from '../../../../../../../types/order';
import { removeRoomFromOrder } from '../../../../../../../store/order/order-reducer';
import PriceViewer from '../../../../../../../components/ui/components/PriceViewer/PriceViewer';
import { pluralize } from '../../../../../../../helpers/translatioHelpers';
import AppText from '../../../../../../../components/ui/typography/AppText/AppText';
import BookButton from '../../../../../../../components/ui/components/Buttons/BookButton/BookButton';
import useSearchForm from '../../../../../common/HotelSearchForm/hooks/useSearchForm';
import { addToOrderThunk } from '../../../../../../../store/order/order-thunk';
import { AppState } from '../../../../../../../store';
import { AppDispatch } from '../../../../../../../../client';
import { createBemClassProp } from '../../../../../../../helpers/common';
import { MobileOnly, TabletAndUpper } from '../../../../../../../components/common/Media/MediaHelpers';
import AppButton from '../../../../../../../components/ui/components/Buttons/AppButton/AppButton';
import IconClose from '../../../../../../../components/ui/icons/icons/IconClose';
import { useTranslation } from 'react-i18next';
import useBookButtonLogic from '../../../../../../../hooks/useBookButtonLogic';
import ErrorModal from '../../../../../../../components/ui/modals/ErrorModal';
import { collectAllErrorToString } from '../../../../../../../helpers/network';

type Props = {
   reservations: ReservationItem[];
   totalRoomsCount: number;
   totalPrice: number;
   onClickOnAddRoom?: () => void
};

const HotelDetailOrderSummarySelectedContent: React.FC<Props> = (props) => {
   const {
      reservations,
      totalPrice,
      totalRoomsCount,
      onClickOnAddRoom,
   } = props;

   const dispatch = useDispatch<AppDispatch>();
   const history = useHistory();
   const isLoading = useSelector((state: AppState) => state.order.isLoading);
   const { nights } = useSearchForm();
   const [t] = useTranslation();

   const { guests, isBookButtonDisabled } = useBookButtonLogic();
   const [errorText, setErrorText] = React.useState<string | undefined>(undefined);

   const onRemove = (reservationId, rateId) => {
      dispatch(removeRoomFromOrder({ roomId: reservationId, rateId }));
   };

   const onBook = async () => {
      const result = await dispatch(addToOrderThunk());

      if (result.error) {
         if (result?.payload?.data?.status_code === 401) history.push('/auth/signin');
         if (result?.payload?.data) {
            setErrorText(collectAllErrorToString(result?.payload?.data));
         }
      } else {
         history.push('/order');
      }

   };

   const renderNotify = () => {
      if (isBookButtonDisabled) {
         return <span {...cn('notify')}>{t('розміщення', { count: Number(guests) })}</span>;
      }

      return null;
   };

   const cn = createBemClassProp('hotel-detail-summary-selected-content');

   return (
      <div {...cn()}>
         {errorText && <ErrorModal onClose={() => setErrorText('')} text={errorText} />}

         <TabletAndUpper>
                <span {...cn('title')}>
                    {t('Обрано')} {pluralize('номер', totalRoomsCount, true)}
                </span>
         </TabletAndUpper>

         <div {...cn('inner')}>
            {reservations.map(reservation => (
               <div {...cn('item')} key={reservation.id}>
                  <div {...cn('item__top-row')}>
                     <AppText variant={'caption'}>{pluralize('номер', reservation.count, true)}</AppText>

                     <button
                        onClick={() => onRemove(reservation.id, reservation.price.rateId)}
                        {...cn('remove-button')}
                     >
                        <IconClose />
                     </button>
                  </div>

                  <div>
                     <span {...cn('room-name')}>{reservation.name}</span>

                     <div className="hotel-detail-summary-selected-content__price">
                        <AppText variant={'caption'}>{t('Ціна за ніч', { count: nights })}</AppText>

                        <div className="hotel-detail-summary-selected-content__price-room-total">
                           {/*{reservation.price.discountAmount > 0 && (*/}
                           {/*    <PriceViewer price={reservation.price.fullPrice} oldPrice/>*/}
                           {/*)}*/}

                           <PriceViewer
                              price={reservation.price.totalPrice}
                              totalAfterDiscount={!!reservation.price.discountAmount}
                           />
                        </div>
                     </div>
                  </div>
               </div>
            ))}

            <MobileOnly>
               <AppButton theme={'outline'} onClick={onClickOnAddRoom}>+ {t('додати номер')}</AppButton>
            </MobileOnly>
         </div>


         <MobileOnly>
            {renderNotify()}
            <div {...cn('buttons')}>
               <AppButton onClick={onBook} theme={'primary'}
                          disabled={isBookButtonDisabled}>{t('Продовжити')}</AppButton>
            </div>
         </MobileOnly>

         <TabletAndUpper>
            {renderNotify()}
            <BookButton
               disabled={isBookButtonDisabled}
               price={totalPrice}
               onClick={onBook}
               isLoading={isLoading}
            />
         </TabletAndUpper>
      </div>
   );
};

export default HotelDetailOrderSummarySelectedContent;
